import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { PRACTICE_HOURS_CONTROLER_URL_List } from "api/Service";
import { showMutationError } from "utils/showMutationError";

export const useUpdatePracticeHours = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");
  const queryClient = useQueryClient();

  return useMutation({
    /*
     * Always the list endpoint, whatever the week's length. The single-day branch this
     * replaces was unreachable while a Save button posted seven days at once, and it
     * posted `details[0]` — with auto-save firing per change it would have become
     * reachable the moment the query returned one row, silently updating one day.
     */
    mutationFn: async (details) => {
      if (!Array.isArray(details) || details.length === 0) return;

      const axiosInstance = createAxiosInstance();

      await axiosInstance.post(
        `${tenantVal}${PRACTICE_HOURS_CONTROLER_URL_List}`,
        details
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["practiceHours"] });
      queryClient.invalidateQueries({ queryKey: ["monthSlotCounts"] });
    },
    onError: (error) =>
      showMutationError(error, "Failed to update practice hours."),
    meta: { skipGlobalError: true },
  });
};
